import mmcrefnum from 'assets/mmc-refnum.png';
import trainingpaperwork from 'assets/training-paperwork.png';

//To add InfoModal to a component, import InfoModal and content as below
//import InfoModal from 'components/widgets/tooltips/InfoModal';
//import content from 'components/widgets/tooltips/InfoModalContent';

//Here in InfoModalContent, name your content object (for example mmcrefnum) and specify title, text, etc.
//If the object doesn't exist, or if all the children (title, text, etc) are empty/nonexistent, the InfoModal will be hidden.

//Then add it inside the component like this <InfoModal content={content.mmcrefnum}/>
//Pray that css puts the info icon in a good spot and/or adjust grids inside component as needed!

//WidgetCard has InfoModal built into the card title and does most of this automatically
//import content to the specific widget component file and call it in WidgetCard
//<WidgetCard infoModalContent={content.vessel}/>

//ChecklistSection also has InfoModal baked in. Use similarly to WidgetCard, like this:
//<ChecklistSection infoModalContent={content.vessel}/>

const content = {
    //AddMMC (home/my-endorsements) and MMCLookup (onboarding)
    mmcrefnum: {
        title: 'MMC Reference Number',
        image_file: mmcrefnum,
        text: 'Your reference number is in the top right corner on the first page of your MMC.',
    },
    //Renewal
    renewals: {
        title: 'Renewing Your USCG License',
        text: 'The display shows how many days you currently have within the last 5 years to renew your license. This is based on your sea service documents that you have entered. The Domestic and International capacities have different requirements. Use the contact button if you have any questions! ',
        video_embed_url: 'https://www.youtube.com/embed/oe8Qt9HLg2w',
        link_url:
            'https://nate-mmseas.medium.com/how-to-renew-your-captains-license-the-nine-easy-steps-aa0147614c02',
        link_label:
            'Click here for more information about renewing your license',
    },
    //SeaService Widgets
    records: {
        title: 'This is your Sea Service History',
        text: 'The Sea Service Credit number is how many days credit the USCG will give you for that time on that vessel. The number may be higher or lower than expected depending on which vessels you are serving on. Check out the Link below which goes into detail on the different types of Sea Service.',
        link_url:
            'https://nate-mmseas.medium.com/sea-service-for-your-uscg-license-defined-fcaf90729903',
        link_label:
            'Click here for more information about how USCG Sea Service works',
    },
    //SeaService Widgets Vessels
    routes: {
        title: 'Route Credit the USCG Will be Giving You',
        text: 'The display shows how many days you currently have at each Route Category the USCG is looking at for your License. This is based on your sea service documents that you have entered ',
        video_embed_url: 'https://www.youtube.com/embed/TSHRUgjdeQI',
        link_url:
            'https://nate-mmseas.medium.com/uscg-sea-service-routes-explained-391cba01810c',
        link_label:
            'Click here for more information about USCG Sea Service Routes',
    },
    vessel: {
        title: 'This is Your Vessel Credit',
        text: 'This shows the total days credit the USCG will be giving you for different types of vessels you sailed on as well as if that time will count for your "within 90 days" needed for recency',
    },
    tonnage: {
        title: 'This is Your Tonnage Credit',
        text: 'Based on your sea service documents, the display shows how many days you currently have at each Tonnage Category that the USCG is looking at for your License',
    },
    horsepower: {
        title: 'This is Your Horsepower Credit',
        text: 'Based on your sea service documents, the display shows how many days you currently have at each Horsepower Category that the USCG is looking at for your License',
    },
    propulsion: {
        title: 'This is Your Propulsion Breakdown',
        text: 'Based on your sea service documents, the display shows how many days you currently have at each Propulsion Category that the USCG is looking at for your License',
    },
    //SeaService Widgets Positions
    position: {
        title: 'This is Your Position Credit',
        text: 'Based on your sea service documents, the display shows how many days you will receive credit from the Coast Guard in each Position Category',
    },
    under_supervision: {
        title: 'This is Your Supervised Position Credit',
        text: 'Based on your sea service documents, the display shows how many days you currently are receiving Under Supervision credit from the Coast Guard for your License',
    },
    department: {
        title: 'This is Your Department Credit',
        text: 'Based on your sea service documents, the display shows how many days you currently are receiving Department credit from the Coast Guard for your License',
    },
    //
    upcomingDates: {
        title: 'This is Your Upcoming Dates',
        text: 'Based on your sea service documents, the display shows important upcoming dates and expirations.',
    },
    upcomingExpirations: {},
    unsubmittedDocuments: {},
    seaServiceJumbo: {},
    //Checklists
    original_checklist: {
        //this populates the infomodal on the checklist title
        title: 'Original MMC definition:',
        text: 'The first credential issued to an applicant.',
    },
    upgrade_checklist: {
        //this populates the infomodal on the checklist title
        title: 'Raise of Grade and Increase in Scope definitions:',
        text: 'RAISE OF GRADE: Increasing the level of authority and responsibility associated with a credential. INCREASE OF SCOPE: Removing limitations previously placed on the credential such as change in horsepower, tonnage limitations, or geographic route.',
    },
    renewal_checklist: {
        //this populates the infomodal on the checklist title
        title: 'Renewal MMC definition:',
        text: 'The re-issuance of a current MMC or previously held credential with a new five year expiration date.',
        video_embed_url: 'https://www.youtube.com/embed/oe8Qt9HLg2w',
        link_url:
            'https://www.mmseas.com/blog/2021/07/15/my-uscg-license-is-expiring-soon/',
        link_label:
            'Click here for more information about Renewing your USCG License',
    },

    //Original Checklist
    original_sea_service: {
        title: 'Step 1: Gather Your Sea Service Documents From Your Career',
        text: 'If you do not have any it is totally ok. If you do, it’s time to gather all of your Sea Service Letters. Go track down every CG-719S (Small Vessel Sea Service form), Sea Service Letter on Company Letterhead, Certificate of Discharge and Active Duty/ Reserve documents (USCG TOSS, Army TOSS, NOAA TOSS, USCG AOPS) of sea service you have earned. UPLOAD every Sea Service document separately into MM-SEAS.',
        video_embed_url: 'https://www.youtube.com/embed/dK6yE77QhHQ',
        link_url:
            'https://www.mmseas.com/blog/2021/07/22/how-to-log-hours-for-captains-license/',
        link_label:
            'Click here for more information about Documenting your Sea Service',
    },
    original_training: {
        title: 'Step 2: Figuring Out if You Have to Take Training or Tests to Get Your First MMC',
        text: 'If you have taken any USCG Approved training add your training certificates to MM-SEAS here. This gives you a secure location to store and organize all of your certificates. You will always have easy access to them from your mobile or desktop device. If you do not have any that is OK! Feel free to reach out if you have any questions about USCG Approved Trainings.',
        image_file: trainingpaperwork,
    },
    original_medical: {
        title: 'Step 3: A Valid Medical Certificate',
        text: 'You need a valid medical certificate for your first MMC. You either need to have an unexpired medical certificate or submit a medical certificate application. Getting your USCG medical certificate is easy. Print off a CG-719K form from the USCG NMC Medical website. Schedule your medical exam with a physician, physician assistant, or nurse practitioner who is licensed in the US or US Territory. Bring the printed form CG-719K with you to your medical exam appointment and have your medical provider complete and sign the form. After your exam, email the completed CG-719K form directly to MEDAIP@uscg.mil. Make sure to include your full name in the subject line of your email to medical. I usually use this format: Last, First, MMC Reference number. Mine would be: Gilman, Nate, 3473478',
        video_embed_url: 'https://www.youtube.com/embed/cmphtigGRtg',
        link_url: 'https://www.dco.uscg.mil/nmc/medical_certificate/',
        link_label:
            'Click here to Print off a CG-719K form from the USCG NMC Medical website',
    },
    original_photocopy_twic: {
        title: 'Step 4: Hold a Valid TWIC or Have Recent Evidence of Applying',
        text: 'Make sure you have a valid TWIC while your application is at the USCG National Maritime Center. To get your TWIC there are three easy steps to follow. The Blog Post below goes into detail for each step with links to everything you need!',
        video_embed_url: 'https://www.youtube.com/embed/iUzbMnXQK5k',
        link_url:
            'https://www.mmseas.com/blog/2021/05/27/step-3-you-need-to-hold-a-valid-twic-or-have-recent-evidence-of-applying-for-a-twic/',
        link_label:
            'Click here for more information about Renewing your TWIC Card',
    },
    original_drug_test: {
        title: 'Step 5: A Negative Drug Test',
        text: 'For all original MMC applications, you’ll need evidence of having passed a chemical test for dangerous drugs. You may also use a letter from a marine employer attesting to participation in a random drug testing program, or a letter attesting to pre-employment drug testing from your employer instead of a drug test.  No matter what type of evidence you use, it must be dated within 185 days of your application being submitted to the Regional Exam Center (REC).',
        video_embed_url: 'https://www.youtube.com/embed/VTWBLGE-PBs',
        link_url:
            'https://www.mmseas.com/blog/2021/09/06/uscg-captains-license-drug-test-for-renewal/',
        link_label:
            'Click here for more information about Drug Test Documentation',
    },
    original_proof_us: {
        title: 'Step 6: Verification of Identity',
        text: 'For all original applications, you’ll need to verify your identity as a US Citizen in one of two ways. You can provide a copy of your unexpired US Passport or your Birth Certificate. No matter what type of evidence you use it must be submitted with your application to the Regional Exam Center (REC). There are two options to meet this requirement. You only need to fulfill one of the options. OPTION ONE: A copy of your unexpired US Passport. OPTION TWO: A copy of your Birth Certificate.',
    },
    original_oath: {
        title: 'Step 7: Merchant Mariner Oath',
        text: 'In this step, you will need to take your Merchant Mariner Oath typically in front of a Notary. Your oath may be administered by any Coast Guard-designated individual or any person legally permitted to administer oaths (This means any notary can help you out!) in the jurisdiction where the person taking the oath resides. Make sure the notary witnesses you reciting your oath and then signs and stamps your oath form.',
        link_url:
            'https://www.dco.uscg.mil/Portals/9/NMC/pdfs/forms/Merchant_Mariner_Oath.pdf',
        link_label:
            'Click here for the oath form provided by the USCG. It says sample on it. But, it works great and you can use it as your oath form.',
    },
    original_fees: {
        title: 'Step 8: Your Federal Fees',
        text: 'You can add your receipt to MM-SEAS or the easier way is to have MM-SEAS automatically take care of paying your fees on your behalf so you don’t have to worry about this confusing and frustrating step.',
        link_url:
            'https://www.mmseas.com/blog/2021/06/01/how-to-renew-your-captains-license-step-4-pay-your-federal-fees/',
        link_label:
            'Click here or more information about paying your Pay.Gov USCG Fees',
    },
    original_profile: {
        title: 'Step 9: Update Your MM-SEAS Profile',
        text: 'We use your complete MM-SEAS user profile to fill out the CG719B we send over to the USCG. Make sure everything is correct before you click submit application.',
    },

    //Renewals Checklist
    renewal_sea_service: {
        title: 'Step 1: Gather Your Sea Service Documents From the Last Five Years',
        text: 'It’s time to gather your Sea Service Letters. Go track down every CG-719S (Small Vessel Sea Service form), Sea Service Letter on Company Letterhead, Certificate of Discharge and Active Duty/ Reserve documents (USCG TOSS, Army TOSS, NOAA TOSS, USCG AOPS) of sea service you have earned. UPLOAD every Sea Service document separately into MM-SEAS.',
        video_embed_url: 'https://www.youtube.com/embed/WtROraTHzbU',
        link_url:
            'https://www.mmseas.com/blog/2021/07/22/how-to-log-hours-for-captains-license/',
        link_label:
            'Click here for more information about Documenting your Sea Service',
    },
    renewal_training_domestic: {
        title: 'Step 2: Figuring Out if You Have to Take Training or Tests to Renew Your License',
        text: 'Add your training certificates to MM-SEAS. This gives you a secure location to store and organize all of your certificates. You will always have easy access to them from your mobile or desktop device.',
        image_file: trainingpaperwork,
        link_url:
            'https://www.mmseas.com/blog/2021/08/18/what-courses-do-i-need-to-renew-my-captains-license-with-360-days/',
        link_label:
            'Click here for more information about Required Trainings with over 360 days of Sea Service',
    },
    renewal_training_stcw: {
        title: 'Step 2: Figuring Out if You Have to Take Training or Tests to Renew Your License',
        text: 'Add your training certificates to MM-SEAS. This gives you a secure location to store and organize all of your certificates. You will always have easy access to them from your mobile or desktop device.',
        image_file: trainingpaperwork,
        link_url:
            'https://www.mmseas.com/blog/2021/08/18/what-courses-do-i-need-to-renew-my-captains-license-with-360-days/',
        link_label:
            'Click here for more information about Required Trainings with over 360 days of Sea Service',
    },
    renewal_training_radar: {
        //text: 'Radar: Avoid hitting the green dots. Constant bearing decreasing range = bad news bears',
    },
    renewal_medical: {
        title: 'Step 3: A Valid Medical Certificate',
        text: 'You need a valid medical certificate for the type of endorsement you are renewing. It must either be an unexpired medical certificate or submit a medical certificate application. Renewing your medical certificate is easy. Print off a CG-719K form from the USCG NMC Medical website. Schedule your medical exam with a physician, physician assistant, or nurse practitioner who is licensed in the US or US Territory. Bring the printed form CG-719K with you to your medical exam appointment and have your medical provider complete and sign the form. After your exam, email the completed CG-719K form directly to MEDAIP@uscg.mil. Make sure to include your full name in the subject line of your email to medical. I usually use this format: Last, First, MMC Reference number. Mine would be: Gilman, Nate, 3473478',
        video_embed_url: 'https://www.youtube.com/embed/cmphtigGRtg',
        link_url: 'https://www.dco.uscg.mil/nmc/medical_certificate/',
        link_label:
            'Click here to Print off a CG-719K form from the USCG NMC Medical website',
    },
    renewal_photocopy_mmc: {
        title: 'Step 4: A Photocopy of Your MMC',
        text: 'Add your MMC pages by taking a picture with your phone of every page on your MMC. This skips the photocopier and allows you to create perfect applications from your phone and desktop. MM-SEAS will store your documents, and automatically alert you as your expiration is coming up.',
    },
    renewal_photocopy_twic: {
        title: 'Step 5: Hold a Valid TWIC or Have Recent Evidence of Applying',
        text: 'There are three easy steps to renew your TWIC. The Blog Post below goes into detail for each step with links to everything you need!',
        video_embed_url: 'https://www.youtube.com/embed/CBr1MY8TZ2w',
        link_url:
            'https://www.mmseas.com/blog/2021/05/27/step-3-you-need-to-hold-a-valid-twic-or-have-recent-evidence-of-applying-for-a-twic/',
        link_label:
            'Click here for more information about Renewing your TWIC Card',
    },
    renewal_drug_test: {
        title: 'Step 6: A Negative Drug Test',
        text: 'For all renewal applications, you’ll need evidence of having passed a chemical test for dangerous drugs. You may also use a letter from a marine employer attesting to participation in a random drug testing program, or a letter attesting to pre-employment drug testing from your employer instead of a drug test. There are a few exceptions to this requirement including increasing in scope, asking for a duplicate, or applying for an STCW only endorsement. No matter what type of evidence you use, it must be dated within 185 days of your application being submitted to the Regional Exam Center (REC).',
        video_embed_url: 'https://www.youtube.com/embed/VTWBLGE-PBs',
        link_url:
            'https://www.mmseas.com/blog/2021/09/06/uscg-captains-license-drug-test-for-renewal/',
        link_label:
            'Click here for more information about Drug Test Documentation',
    },
    renewal_fees: {
        title: 'Step 7: Your Federal Fees',
        text: 'You can add your receipt or the easier way is to have MM-SEAS automatically take care of paying your fees on your behalf so you don’t have to worry about this confusing and frustrating step. Here are some helpful hints if you want to pay for them yourself. CREDENTIAL CATEGORY: Select the types of endorsements you are renewing. EXAMINATION/ TESTING FEES: If you are renewing with over 360 days of sea time select any $0 option. If you are renewing with less than 360 sea days select the Officer Renewal/ Raise of Grade/ Modification $45 option no matter what you are renewing. ISSUANCE FEES: Select the Pay MMC issuance fee now $45 option. MAKE SURE TO SAVE YOUR EMAIL RECEIPT AS A PDF AND UPLOAD IT TO MM-SEAS',
        video_embed_url: 'https://www.youtube.com/embed/1d3D-FfAb8c',
        link_url:
            'https://www.mmseas.com/blog/2021/06/01/how-to-renew-your-captains-license-step-4-pay-your-federal-fees/',
        link_label:
            'Click here or more information about paying your Pay.Gov USCG Fees',
    },
    renewal_profile: {
        title: 'Step 8: Update Your MM-SEAS Profile',
        text: 'We use your complete MM-SEAS user profile to fill out the CG719B we send over to the USCG. Make sure everything is correct before you click submit application.',
    },

    //Upgrade Checklist
    upgrade_sea_service: {
        title: 'Step 1: Gather Your Sea Service Documents From Your Career',
        text: 'It’s time to gather all of your Sea Service Letters. Go track down every CG-719S (Small Vessel Sea Service form), Sea Service Letter on Company Letterhead, Certificate of Discharge and Active Duty/ Reserve documents (USCG TOSS, Army TOSS, NOAA TOSS, USCG AOPS) of sea service you have earned. UPLOAD the Sea Service documents separately that will help you with your upgrade.',
        link_url:
            'https://www.mmseas.com/blog/2021/07/22/how-to-log-hours-for-captains-license/',
        link_label:
            'Click here for more information about Documenting your Sea Service',
    },
    upgrade_training: {
        title: 'Step 2: Figuring Out if You Have to Take Training or Tests to Upgrade Your License',
        text: 'Add your training certificates to MM-SEAS. This gives you a secure location to store and organize all of your certificates. You will always have easy access to them from your mobile or desktop device.',
        image_file: trainingpaperwork,
    },
    upgrade_medical: {
        title: 'Step 3: A Valid Medical Certificate',
        text: 'You need a valid medical certificate for the type of endorsement you are renewing. It must either be an unexpired medical certificate or submit a medical certificate application. Renewing your medical certificate is easy. Print off a CG-719K form from the USCG NMC Medical website. Schedule your medical exam with a physician, physician assistant, or nurse practitioner who is licensed in the US or US Territory. Bring the printed form CG-719K with you to your medical exam appointment and have your medical provider complete and sign the form. After your exam, email the completed CG-719K form directly to MEDAIP@uscg.mil. Make sure to include your full name in the subject line of your email to medical. I usually use this format: Last, First, MMC Reference number. Mine would be: Gilman, Nate, 3473478',
        video_embed_url: 'https://www.youtube.com/embed/cmphtigGRtg',
        link_url: 'https://www.dco.uscg.mil/nmc/medical_certificate/',
        link_label:
            'Click here to Print off a CG-719K form from the USCG NMC Medical website',
    },
    upgrade_photocopy_mmc: {
        title: 'Step 4: A Photocopy of Your MMC',
        text: 'Add your MMC pages by taking a picture with your phone of every page on your MMC. This skips the photocopier and allows you to create perfect applications from your phone and desktop. MM-SEAS will store your documents, and automatically alert you as your expiration is coming up.',
    },
    upgrade_photocopy_twic: {
        title: 'Step 5: Hold a Valid TWIC or Have Recent Evidence of Applying',
        text: 'Make sure you have a valid TWIC while your application is at the USCG National Maritime Center. If you need to renew there are three easy steps to follow. The Blog Post below goes into detail for each step with links to everything you need!',
        video_embed_url: 'https://www.youtube.com/embed/CBr1MY8TZ2w',
        link_url:
            'https://www.mmseas.com/blog/2021/05/27/step-3-you-need-to-hold-a-valid-twic-or-have-recent-evidence-of-applying-for-a-twic/',
        link_label:
            'Click here for more information about Renewing your TWIC Card',
    },
    upgrade_drug_test: {
        title: 'Step 6: A Negative Drug Test',
        text: 'For most upgrade applications, you’ll need evidence of having passed a chemical test for dangerous drugs. The only type of applications that do not require a drug test are increasing in scope and adding STCW only to your MMC. You may also use a letter from a marine employer attesting to participation in a random drug testing program, or a letter attesting to pre-employment drug testing from your employer instead of a drug test. There are a few exceptions to this requirement including increasing in scope, asking for a duplicate, or applying for an STCW only endorsement. No matter what type of evidence you use, it must be dated within 185 days of your application being submitted to the Regional Exam Center (REC).',
        video_embed_url: 'https://www.youtube.com/embed/VTWBLGE-PBs',
        link_url:
            'https://www.mmseas.com/blog/2021/09/06/uscg-captains-license-drug-test-for-renewal/',
        link_label:
            'Click here for more information about Drug Test Documentation',
    },
    upgrade_fees: {
        title: 'Step 7: Your Federal Fees',
        text: 'You can add your receipt to MM-SEAS or the easier way is to have MM-SEAS automatically take care of paying your fees on your behalf so you don’t have to worry about this confusing and frustrating step.',
        link_url:
            'https://www.mmseas.com/blog/2021/06/01/how-to-renew-your-captains-license-step-4-pay-your-federal-fees/',
        link_label:
            'Click here or more information about paying your Pay.Gov USCG Fees',
    },
    upgrade_profile: {
        title: 'Step 8: Update Your MM-SEAS Profile',
        text: 'We use your complete MM-SEAS user profile to fill out the CG719B we send over to the USCG. Make sure everything is correct before you click submit application.',
    },
    upgrade_rating: {},
};
export default content;
